import { Fragment } from 'react';

import MoreButton from '@/components/MoreButton';
import useNavigateWithAnimation from '@/helpers/useNavigateWithAnimation';
import CommunityBigCard from '@/app/community/components/CommunityBigCard';
import CommunitySmallCard from '@/app/community/components/CommunitySmallCard';
import usePageState from '@/context/pageStates/pageStateHook';
import textConstant from '@/dictionaries/fa.json';

const CommunitiesHorizontalList = ({ list, bigCardMode, listCount = 0 }) => {
    const { navigateWithAnimation } = useNavigateWithAnimation();
    const {
        communitiesListPage: { current: communitiesListPageState }
    } = usePageState();
    // RF: guess it would be better to separate userCommunities and allCommunities horizontal component
    // from each other, because there is little similarity between them

    const handleMoreButtonClick = () => {
        if (!bigCardMode) {
            if (communitiesListPageState.activeTabId !== 2) {
                /* for user communities horizontal list */
                communitiesListPageState.activeTabId = 2;
                communitiesListPageState.scrollPosition = 0;
            }
        } else {
            if (communitiesListPageState.activeTabId === 2) {
                /* for user communities horizontal list */
                communitiesListPageState.activeTabId = 1;
                communitiesListPageState.scrollPosition = 0;
            }
        }
        navigateWithAnimation({ link: '/community' });
    };

    const handleCommunityClick = (id) => {
        navigateWithAnimation({ link: `/community/${id}` });
    };
    return (
        <div className={`communities-horizontal-list-container ${!bigCardMode && 'has-border'}`}>
            {bigCardMode && (
                <div className="communities-horizontal-list-header">
                    <h2 className="list-header-title">{textConstant.communityPage.communities}</h2>
                    <MoreButton to="/community/list" onClick={handleMoreButtonClick} />
                </div>
            )}

            <div className="communities-horizontal-list  hide-scroll">
                {list?.map((community, index) => (
                    <Fragment key={index}>
                        {bigCardMode ? (
                            <CommunityBigCard
                                communityData={community}
                                onClick={handleCommunityClick}
                            />
                        ) : (
                            <CommunitySmallCard data={community} onClick={handleCommunityClick} />
                        )}
                    </Fragment>
                ))}

                {!bigCardMode && listCount && listCount > 12 && (
                    <div className="community-small-card-container" onClick={handleMoreButtonClick}>
                        <span className="communities-more-count-container">+{listCount - 12}</span>
                        <span className="community-small-card-title">{textConstant.showAll}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CommunitiesHorizontalList;
